<template>
  <div class="home-container1">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="glas-in-lood-section-separator1"></div>
    <div class="glas-in-lood-section-separator2"></div>
    <div class="glas-in-lood-container12">
      <div class="glas-in-lood-features">
        <h1 class="glas-in-lood-text10">Glas-in-lood</h1>
        <div class="glas-in-lood-container13">
          <feature-card2
            title="Glas-in-lood in dubbel glas"
            description="Theo Brandt kan jouw glas-in-lood ruit in dubbel glas plaatsen!"
            rootClassName="rootClassName4"
          ></feature-card2>
          <feature-card2
            title="Gerestaureerd"
            description="Het repareren van glas-in-lood kan natuurlijk ook! Wanneer er een stukje glas als enigste vervangen moet worden kan dit natuurlijk."
            rootClassName="rootClassName5"
          ></feature-card2>

          <feature-card2
            title="Nieuw Glas-in-lood ruit maken"
            description="Wilt u een nieuw glas-in-lood raam geplaatst hebben? Dat kan! Als u een eigen ontwerp hebt kan Theo Brandt deze tot leven brengen. Natuurlijk kan hij je ook helpen met het maken van een ontwerp of je kan het aan Theo over laten om een mooi ruit voor je te maken!"
            rootClassName="rootClassName7"
          ></feature-card2>
        </div>
      </div>
    </div>

    <div class="glas-in-lood-container14">
      <div class="glas-in-lood-gallery1">
        <h1 class="glas-in-lood-text11">Glas-in-lood in dubbel glas</h1>
        <span class="glas-in-lood-text12">
          <br />
          <span>
            Onderstaande projecten heeft Theo Brandt in dubbel glas gemonteerd.
          </span>
        </span>
        <div class="glas-in-lood-container15">
          <gallery-card31
            imageSrc="glas in lood/3 luik.JPG"
            title="3 luik smal"
            rootClassName="rootClassName"
          ></gallery-card31>
          <gallery-card31
            imageSrc="glas in lood/3 luik 2.JPG"
            title="3 luik breed"
            rootClassName="rootClassName1"
          ></gallery-card31>
        </div>
      </div>
    </div>
    <div class="glas-in-lood-container16">
      <div class="glas-in-lood-gallery2">
        <h1 class="glas-in-lood-text15">
          <span>Gerestaureerd</span>
          <br />
        </h1>
        <span class="glas-in-lood-text18">
          <br />
          <span>
            Onderstaande glas-in-lood ruiten heeft Theo Brandt gerestaureerd.
          </span>
        </span>
        <div class="glas-in-lood-container17">
          <gallery-card31
            rootClassName="rootClassName8"
            imageSrc="glas in lood/Restauratie werk.jpg"
            title="Restauratie werk"
          ></gallery-card31>
          <gallery-card31
            imageSrc="glas in lood/20180918_121825.jpg"
            title="J. Peters BV ruit"
            rootClassName="rootClassName9"
          ></gallery-card31>
          <gallery-card31
            imageSrc="glas in lood/20220818_204618.jpg"
            title="Ruit-1"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/20230918_142942.jpg"
            title="Ruit-2"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/20231023_172418.jpg"
            title="Ruit-3"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/20231005_111838.jpg"
            title="Ruit-4"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/IMG_20210402_101848_176.jpg"
            title="Ruit-5"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/IMG-20220206-WA0000.jpg"
            title="Ruit-6"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/IMG_20210402_102904_131.jpg"
            title="Ruit-7"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/Screenshot_2016-03-06-14-49-42.png"
            title="Ruit-8"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/Screenshot_2016-03-06-15-00-52.png"
            title="Ruit-9"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/Screenshot_2016-06-14-21-18-57.png"
            title="Ruit-10"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/Screenshot_2016-06-14-21-19-07.png"
            title="Ruit-11"
            rootClassName="rootClassName9"
          ></gallery-card31
          ><gallery-card31
            imageSrc="glas in lood/Screenshot_2016-06-14-21-19-22.png"
            title="Ruit-12"
            rootClassName="rootClassName9"
          ></gallery-card31>
        </div>
      </div>
      <div class="glas-in-lood-container18">
        <div class="glas-in-lood-gallery3">
          <h1 class="glas-in-lood-text21">Nieuwe glas in lood ruit</h1>
          <span class="glas-in-lood-text22">
            <br />
            <span>
              Onderstaande glas-in-lood ruiten heeft Theo Brandt zelf ontworpen
              en gemaakt. 
            </span>
          </span>
          <div class="glas-in-lood-container19">
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/dakkoepel-paneel.JPG"
              title="Dakkoepel paneel"
              rootClassName="rootClassName16"
            ></gallery-card31>
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/Deur paneel.jpg"
              title="Deur paneel"
              rootClassName="rootClassName17"
            ></gallery-card31
            ><gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/eindresultaat hoorn 1.JPG"
              title="Botter Hoorn1"
              rootClassName="rootClassName17"
            ></gallery-card31
            ><gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/IMG_20210402_104615_588.jpg"
              title="Ruit Westerdijk"
              rootClassName="rootClassName17"
            ></gallery-card31
            ><gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/IMG_20210402_105042_787.jpg"
              title="Dancing ballerina's"
              rootClassName="rootClassName17"
            ></gallery-card31
            ><gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/Kantoor paneel.jpg"
              title="Ruit"
              rootClassName="rootClassName17"
            ></gallery-card31>
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/IMG_20210402_105042_777.jpg"
              title="Ruit 2 kanten"
              rootClassName="rootClassName17"
            ></gallery-card31>
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/Screenshot_2016-03-06-14-06-41.png"
              title="4 panelen"
              rootClassName="rootClassName17"
            ></gallery-card31
            ><gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/voorbeeld serre bovenlichten.JPG"
              title="Serre bovenlichten"
              rootClassName="rootClassName17"
            ></gallery-card31
            ><gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/woning Wervershoof.JPG"
              title="Bloem Onderdijk"
              rootClassName="rootClassName17"
            ></gallery-card31
            ><gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/IMG-20230502-WA0000.jpg"
              title="Ruit onderwater"
              rootClassName="rootClassName17"
            ></gallery-card31>

            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/20191209_155533.jpg"
              title="Duo in deur"
              rootClassName="rootClassName17"
            ></gallery-card31>
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/20181130_122245.jpg"
              title="Tiffany vervangen door glas-in-lood in spouwglas gebouwd"
              rootClassName="rootClassName17"
            ></gallery-card31>
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/IMG_20210402_101848_190.jpg"
              title="Van 3 panelen 1 gemaakt"
              rootClassName="rootClassName17"
            ></gallery-card31>
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/02022008091.jpg"
              title="Tulpen ruit"
              rootClassName="rootClassName17"
            ></gallery-card31>
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/vliegers 2.JPG"
              title="Vliegers ruit"
              rootClassName="rootClassName17"
            ></gallery-card31>
            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/20190216_101821.jpg"
              title="Ruiten in deur"
              rootClassName="rootClassName17"
            ></gallery-card31>

            <gallery-card31
              imageSrc="glas in lood/nieuwe ruit maken/20140604_071630.jpg"
              title="Bovenruiten Kerkplein Hoorn"
              rootClassName="rootClassName17"
            ></gallery-card31>

            <gallery-card31
              imageSrc="glas in lood/tabascoHoorn.jpeg"
              title="Ruit Tabasco Hoorn"
              rootClassName="rootClassName17"
            ></gallery-card31>

            <gallery-card31
              imageSrc="glas in lood/tabascoHoorn2.jpeg"
              title="Ruit Tabasco Hoorn"
              rootClassName="rootClassName17"
            ></gallery-card31>

            <Slideshow
              :slides="prooi"
              title="Paneel film Prooi van Dick Maas"
              rootClassName="rootClassName17"
            ></Slideshow>

            <Slideshow
              :slides="kerhofBlokker"
              title="Kapel kerkhof Blokker"
              rootClassName="rootClassName17"
            ></Slideshow>
          </div>
          <br />
          <br />
          <h1 class="glas-in-lood-text15">
            <span>Progressie van werkstukken</span>
            <br />
          </h1>
          <div class="glas-in-lood-containerprogression">
            <Slideshow :slides="egypt_eye_slides" />
            <Slideshow :slides="accuSlides" />
            <Slideshow :slides="ruitSlides" />
            <Slideshow :slides="gammaSlides" />
            <Slideshow :slides="langRaamSlides" />
            <Slideshow :slides="paneelSlides" />
            <Slideshow :slides="koeman" />
            <Slideshow :slides="bloemen" />
          </div>
        </div>
      </div>
    </div>
    <div class="glas-in-lood-section-separator6"></div>
    <div class="glas-in-lood-section-separator7"></div>
    <div class="glas-in-lood-footer-container">
      <Footer />
    </div>
  </div>
</template>

<script>
import FeatureCard2 from "../components/feature-card2";
import GalleryCard31 from "../components/gallery-card31";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Slideshow from "../components/slideshow.vue";

export default {
  name: "GlasInLood",
  props: {},
  components: {
    FeatureCard2,
    GalleryCard31,
    Navbar,
    Footer,
    Slideshow,
  },
  metaInfo: {
    title: "Glas-in-lood - Langglas",
    meta: [
      {
        property: "og:title",
        content: "Glas-in-lood - Langglas",
      },
    ],
  },
  data() {
    return {
      bloemen: [
        {
          title: "Snijden sneeuwklokjes ruit",
          imageSrc: "/glas in lood/bloemen1.jpeg",
          imageAlt: "Sneeuwklokjes",
        },
        {
          title: "Opbouw sneeuwklokjes ruit",
          imageSrc: "/glas in lood/bloemen2.jpeg",
          imageAlt: "opbouw sneeuwklokjes",
        },
        {
          title: "Enkel geplaatst sneeuwklokjes ruit",
          imageSrc: "/glas in lood/bloemen3.jpeg",
          imageAlt: "enkel sneeuwklokjes",
        },
        {
          title: "Eindresultaat sneeuwklokjes ruiten",
          imageSrc: "/glas in lood/bloemen4.jpeg",
          imageAlt: "resultaat sneeuwklokjes",
        },
      ],
      koeman: [
        {
          title: "Snijden koeman ruit",
          imageSrc: "/glas in lood/snijdenKoe.jpeg",
          imageAlt: "Koeman paneel",
        },
        {
          title: "Opbouw koeman ruit",
          imageSrc: "/glas in lood/opbouwKoe.jpeg",
          imageAlt: "Opbouw koe ruit",
        },
        {
          title: "Koe ruit resultaat",
          imageSrc: "/glas in lood/koeKlaar.jpeg",
          imageAlt: "Koe ruit resultaat",
        },
        {
          title: "Plaatsen koeman ruit",
          imageSrc: "/glas in lood/plaatsenKoe.jpeg",
          imageAlt: "Plaatsen ruit",
        },
        {
          title: "Eindresultaat koeman ruit",
          imageSrc: "/glas in lood/geplaatsteKoe.jpeg",
          imageAlt: "Eindresultaat koe ruit",
        },
      ],
      kerhofBlokker: [
        {
          title: "Kapel kerkhof Blokker",
          imageSrc: "/glas in lood/kerkhofBlokkerVer.jpeg",
          imageAlt: "Kapel kerkhof Blokker",
        },
        {
          title: "Kapel kerkhof Blokker",
          imageSrc: "/glas in lood/kerkhofBlokkerDichtbij.jpeg",
          imageAlt: "Kapel kerkhof Blokker dichtbij",
        },
        {
          title: "Kapel kerkhof Blokker",
          imageSrc: "/glas in lood/kerkhofBlokkerKleur.jpeg",
          imageAlt: "Kapel kerkhof Blokker Kleur",
        },
      ],
      prooi: [
        {
          title: "Glas in lood paneel film Prooi Dick Maas",
          imageSrc: "/glas in lood/prooiHelePaneel.jpeg",
          imageAlt: "Hele paneel",
        },
        {
          title: "Prooi paneel dichtbij",
          imageSrc: "/glas in lood/prooiLeeg.jpeg",
          imageAlt: "Paneel dichtbij",
        },
        {
          title: "Prooi paneel met achtergrond",
          imageSrc: "/glas in lood/prooiAchtergrond.jpeg",
          imageAlt: "Paneel met achtergrond",
        },
      ],
      egypt_eye_slides: [
        {
          title: "Snijden Egyptisch oog",
          imageSrc: "/glas in lood/snijden egyptisch oog.jpg",
          imageAlt: "Snijden",
        },
        {
          title: "Opbouw Egyptisch oog",
          imageSrc: "/glas in lood/opbouw egyptisch oog 2.JPG",
          imageAlt: "Opbouw",
        },
        {
          title: "Egyptisch oog",
          imageSrc: "/glas in lood/eindresultaat oog.JPG",
          imageAlt: "Egyptisch oog",
        },
        {
          title: "Plaatsen Egyptisch oog",
          imageSrc: "/glas in lood/plaatsen egyptisch oog.JPG",
          imageAlt: "Plaatsen",
        },
        {
          title: "Eindresultaat Egyptisch oog",
          imageSrc: "/glas in lood/eindresutaat oog.JPG",
          imageAlt: "Einderesultaat",
        },
      ],
      accuSlides: [
        {
          title: "Snijden Wari accu",
          imageSrc: "/glas in lood/nieuwe ruit maken/opbouw accu.JPG",
          imageAlt: "Opbouw accu",
        },
        {
          title: "Eindresultaat Wari accu",
          imageSrc: "/glas in lood/nieuwe ruit maken/eindresultaat accu.JPG",
          imageAlt: "Accu",
        },
      ],
      ruitSlides: [
        {
          title: "Snijden paneel",
          imageSrc: "/glas in lood/nieuwe ruit maken/20241116_142659.jpg",
          imageAlt: "Snijden ruit",
        },
        {
          title: "Eindresultaat paneel",
          imageSrc: "/glas in lood/nieuwe ruit maken/20241116_143652.jpg",
          imageAlt: "Einresultaat ruit",
        },
      ],
      gammaSlides: [
        {
          title: "Ontwerp voor in deur",
          imageSrc:
            "/glas in lood/nieuwe ruit maken/ontworpen voor in gamma-deur.JPG",
          imageAlt: "Snijden gamma",
        },
        {
          title: "Geplaatst in deur",
          imageSrc:
            "/glas in lood/nieuwe ruit maken/geplaatst in gamma deur.JPG",
          imageAlt: "Eindresultaat gamma",
        },
      ],
      langRaamSlides: [
        {
          title: "Ontwerp lang raam",
          imageSrc: "/glas in lood/nieuwe ruit maken/langraam 3mtr.JPG",
          imageAlt: "Ontwerp lang raam",
        },
        {
          title: "Geplaatst lang raam",
          imageSrc:
            "/glas in lood/nieuwe ruit maken/langraam geplaatst in spouwglas.JPG",
          imageAlt: "Eindresultaat lang raam",
        },
      ],
      paneelSlides: [
        {
          title: "Opbouw paneel",
          imageSrc: "/glas in lood/nieuwe ruit maken/opbouw paneel.JPG",
          imageAlt: "Paneel",
        },
        {
          title: "Eindresultaat paneel",
          imageSrc: "/glas in lood/nieuwe ruit maken/20150209_142634.jpg",
          imageAlt: "Paneel",
        },
      ],
    };
  },
};
</script>

<style scoped>
.home-container1 {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-navbar-container {
  top: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
}
.glas-in-lood-heading1 {
  color: #000000;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.glas-in-lood-links-container1 {
  width: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.glas-in-lood-link10 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.glas-in-lood-link11 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.glas-in-lood-link12 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.glas-in-lood-link13 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.glas-in-lood-link14 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.glas-in-lood-link15 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.glas-in-lood-burger-menu {
  display: none;
  align-items: flex-start;
  flex-direction: column;
}
.glas-in-lood-icon1 {
  width: 36px;
  height: 36px;
}
.glas-in-lood-mobile-menu {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  display: none;
  padding: var(--dl-space-space-tripleunit);
  position: absolute;
  align-items: flex-start;
  flex-direction: column;
  background-color: #fff;
}
.glas-in-lood-container11 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}
.glas-in-lood-close-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.glas-in-lood-icon3 {
  width: 24px;
  height: 24px;
}
.glas-in-lood-links-container2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.glas-in-lood-link16 {
  margin-bottom: var(--dl-space-space-unit);
}
.glas-in-lood-link17 {
  margin-bottom: var(--dl-space-space-unit);
}
.glas-in-lood-link18 {
  margin-bottom: var(--dl-space-space-unit);
}
.glas-in-lood-section-separator1 {
  width: 100%;
  height: 1px;
  display: flex;
  margin-top: var(--dl-space-space-tenunits);
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glas-in-lood-section-separator2 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glas-in-lood-container12 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.glas-in-lood-features {
  width: 100%;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  flex-direction: column;
}
.glas-in-lood-text10 {
  font-size: 3rem;
  margin-bottom: 48px;
}
.glas-in-lood-container13 {
  width: 100%;
  display: grid;
  grid-gap: 32px;
  grid-template-columns: 1fr 1fr;
}
.glas-in-lood-container14 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #ffffff;
}
.glas-in-lood-gallery1 {
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.glas-in-lood-text11 {
  font-size: 3rem;
  align-self: flex-start;
  text-align: center;
}
.glas-in-lood-text12 {
  color: var(--dl-color-gray-700);
  height: 100%;
  font-size: 24px;
  align-self: flex-start;
  text-align: left;
  padding-left: var(--dl-space-space-halfunit);
  padding-right: var(--dl-space-space-halfunit);
}
.glas-in-lood-container15 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.glas-in-lood-container16 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #f1f1f1;
}
.glas-in-lood-gallery2 {
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.glas-in-lood-text15 {
  font-size: 3rem;
  align-self: flex-start;
  text-align: center;
}
.glas-in-lood-text18 {
  color: var(--dl-color-gray-700);
  height: 100%;
  font-size: 24px;
  align-self: flex-start;
  text-align: left;
  padding-left: var(--dl-space-space-halfunit);
  padding-right: var(--dl-space-space-halfunit);
}
.glas-in-lood-container17 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.glas-in-lood-container18 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #ffffff;
}
.glas-in-lood-gallery3 {
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.glas-in-lood-text21 {
  font-size: 3rem;
  align-self: flex-start;
  text-align: center;
}
.glas-in-lood-text22 {
  color: var(--dl-color-gray-700);
  height: 100%;
  font-size: 24px;
  align-self: flex-start;
  text-align: left;
  padding-left: var(--dl-space-space-halfunit);
  padding-right: var(--dl-space-space-halfunit);
}
.glas-in-lood-container19 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.glas-in-lood-containerprogression {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr;
}

.glas-in-lood-container20 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #f1f1f1;
}
.glas-in-lood-gallery4 {
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.glas-in-lood-text25 {
  font-size: 3rem;
  align-self: flex-start;
  text-align: center;
}
.glas-in-lood-text28 {
  color: var(--dl-color-gray-700);
  height: 100%;
  font-size: 24px;
  align-self: flex-start;
  text-align: left;
  padding-left: var(--dl-space-space-halfunit);
  padding-right: var(--dl-space-space-halfunit);
}
.glas-in-lood-container21 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.glas-in-lood-container22 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #ffffff;
}
.glas-in-lood-gallery5 {
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.glas-in-lood-text31 {
  font-size: 3rem;
  align-self: flex-start;
  text-align: center;
}
.glas-in-lood-text32 {
  color: var(--dl-color-gray-700);
  height: 100%;
  font-size: 24px;
  align-self: flex-start;
  text-align: left;
  padding-left: var(--dl-space-space-halfunit);
  padding-right: var(--dl-space-space-halfunit);
}
.glas-in-lood-container23 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.glas-in-lood-section-separator3 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glas-in-lood-section-separator4 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glas-in-lood-section-separator5 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glas-in-lood-section-separator6 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glas-in-lood-section-separator7 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glas-in-lood-footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}
.glas-in-lood-footer {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}
.glas-in-lood-copyright-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.glas-in-lood-icon5 {
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
@media (max-width: 1600px) {
  .glas-in-lood-navbar {
    width: 100%;
  }
  .glas-in-lood-footer {
    justify-content: center;
  }
}
@media (max-width: 1200px) {
  .glas-in-lood-navbar {
    width: 100%;
  }
  .glas-in-lood-heading1 {
    margin-right: var(--dl-space-space-fourunits);
  }
  .glas-in-lood-links-container1 {
    width: auto;
    position: relative;
  }
  .glas-in-lood-link10 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link11 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link12 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link13 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link14 {
    width: auto;
  }
  .glas-in-lood-link15 {
    width: auto;
  }
}
@media (max-width: 991px) {
  .glas-in-lood-heading1 {
    text-align: center;
  }
  .glas-in-lood-links-container1 {
    width: 424px;
    display: none;
  }
  .glas-in-lood-link10 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link11 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link12 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link13 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link14 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-link15 {
    width: auto;
    height: auto;
  }
  .glas-in-lood-burger-menu {
    display: flex;
  }
  .glas-in-lood-heading2 {
    text-align: center;
  }
  .glas-in-lood-text12 {
    text-align: center;
  }
  .glas-in-lood-container15 {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .glas-in-lood-text18 {
    text-align: center;
  }
  .glas-in-lood-container17 {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .glas-in-lood-text22 {
    text-align: center;
  }
  .glas-in-lood-container19 {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .glas-in-lood-text28 {
    text-align: center;
  }
  .glas-in-lood-container21 {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .glas-in-lood-text32 {
    text-align: center;
  }
  .glas-in-lood-container23 {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 767px) {
  .glas-in-lood-navbar {
    position: relative;
  }
  .glas-in-lood-links-container1 {
    display: none;
  }
  .glas-in-lood-burger-menu {
    display: flex;
    padding: var(--dl-space-space-halfunit);
    margin-left: var(--dl-space-space-tripleunit);
    border-radius: var(--dl-radius-radius-radius4);
    background-color: var(--dl-color-gray-black);
  }
  .glas-in-lood-icon1 {
    fill: var(--dl-color-gray-white);
  }
  .glas-in-lood-features {
    padding-left: 32px;
    padding-right: 32px;
  }
  .glas-in-lood-container13 {
    grid-template-columns: 1fr;
  }
  .glas-in-lood-gallery1 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .glas-in-lood-text12 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .glas-in-lood-container15 {
    grid-template-columns: 1fr 1fr;
  }
  .glas-in-lood-gallery2 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .glas-in-lood-text18 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .glas-in-lood-container17 {
    grid-template-columns: 1fr 1fr;
  }
  .glas-in-lood-gallery3 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .glas-in-lood-text22 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .glas-in-lood-container19 {
    grid-template-columns: 1fr 1fr;
  }
  .glas-in-lood-gallery4 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .glas-in-lood-text28 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .glas-in-lood-container21 {
    grid-template-columns: 1fr 1fr;
  }
  .glas-in-lood-gallery5 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .glas-in-lood-text32 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .glas-in-lood-container23 {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 479px) {
  .glas-in-lood-burger-menu {
    margin-left: var(--dl-space-space-doubleunit);
  }
  .glas-in-lood-features {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .glas-in-lood-gallery1 {
    padding: var(--dl-space-space-unit);
  }
  .glas-in-lood-container15 {
    grid-template-columns: 1fr;
  }
  .glas-in-lood-gallery2 {
    padding: var(--dl-space-space-unit);
  }
  .glas-in-lood-container17 {
    grid-template-columns: 1fr;
  }
  .glas-in-lood-gallery3 {
    padding: var(--dl-space-space-unit);
  }
  .glas-in-lood-container19 {
    grid-template-columns: 1fr;
  }
  .glas-in-lood-containerprogression {
    grid-template-columns: 1fr;
  }
  .glas-in-lood-gallery4 {
    padding: var(--dl-space-space-unit);
  }
  .glas-in-lood-container21 {
    grid-template-columns: 1fr;
  }
  .glas-in-lood-gallery5 {
    padding: var(--dl-space-space-unit);
  }
  .glas-in-lood-container23 {
    grid-template-columns: 1fr;
  }
}
</style>
